import * as React from "react";
import {
  TaskBoardWrapper,
  TaskGameName,
} from "src/components/Table/TaskBoard/TaskBoard.components";

interface Props {
  gameName?: string;
}

const TaskBoard: React.FunctionComponent<Props> = ({ gameName, children 
}) => {
  return (
    <TaskBoardWrapper data-cy="taskBoard">
      <TaskGameName>{gameName}</TaskGameName>
      {children}
    </TaskBoardWrapper>
  );
};


export default TaskBoard;
